export const DEFAULT_SCHEDULE_ORDER_BY = ['start_utc', 'order', 'name'];

export const SCHEDULE_SESSION_DISPLAY_TYPE_DEFAULT = 'default',
    SCHEDULE_SESSION_DISPLAY_TYPE_ROUND = 'round',
    SCHEDULE_SESSION_DISPLAY_TYPE_BREAK = 'break',
    SCHEDULE_SESSION_DISPLAY_TYPE_SPEEDDATE = 'speeddate',
    SCHEDULE_SESSION_DISPLAY_TYPE_ONLINE = 'online';
